import { render, staticRenderFns } from "./blogs2.vue?vue&type=template&id=138b6b33&scoped=true"
import script from "./blogs2.vue?vue&type=script&lang=js"
export * from "./blogs2.vue?vue&type=script&lang=js"
import style0 from "./blogs2.vue?vue&type=style&index=0&id=138b6b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b6b33",
  null
  
)

export default component.exports